import { render } from "./hazardratiocoif.vue?vue&type=template&id=6efd3d36&scoped=true"
import script from "./hazardratiocoif.vue?vue&type=script&lang=js"
export * from "./hazardratiocoif.vue?vue&type=script&lang=js"

import "./hazardratiocoif.vue?vue&type=style&index=0&id=6efd3d36&lang=css"
import "./hazardratiocoif.vue?vue&type=style&index=1&id=6efd3d36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efd3d36"]])

export default __exports__